<template>
    <div class='filter-section'>
        <div v-for='filter in star_filters' :key='filter' class='filter-content' @click='selectReviewFilter(filter.rating)'>
            <div class='rating-number'>{{filter.rating}}</div> 
            <i class="fa-sharp fa-solid fa-star star"></i> 
            <div class="bar" :style='"--rating: " + filter.percentage + "%"'></div>
            <div class='review-count'>{{filter.count}}</div>
        </div>

        <div v-show='selected_rating != 0' class='view-all-reviews-text' @click='selectReviewFilter(0)'>View all reviews</div>
    </div>
</template>

<script>
export default {
    props: ['star_filters'],
    emits: ['reviewFilterListener'],
    data(){
        return{
            selected_rating: 0
        }
    },
    methods:{
        selectReviewFilter(rating){
            this.selected_rating = rating;
            this.$emit('reviewFilterListener', rating);
        }
    }
}
</script>

<style lang="scss" scoped>

.filter-section{
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.filter-content{
    display: flex;
    gap: 10px;
    align-items: center;
    font-size: 0.9rem;
    cursor: pointer;
}

.star{
    color: var(--black);
    font-size: 1.2rem;
}

.rating-number{
    width: 8px;
    text-align: center;
}
.review-count{
    width: 8px;
    text-align: center;
    font-size: 1rem;
}
.bar {
    width: 300px;
    height: 8px;
    background-color: #adb5bd;
    position: relative;
    
    &::after {
        content: '\A';
        position: absolute;
        background: var(--black);
        top: 0; bottom: 0;
        left: 0; 
        width: var(--rating)
    }
    @media(max-width: 768px){
        width: 200px;
    }
}

.view-all-reviews-text{
    cursor: pointer;
    font-size: 1rem;
    margin-top: 20px;
    text-decoration: underline;
}
</style>